export enum PointOfContactRoles {
  Main = 'Main',
  Secondary = 'Secondary',
  EmergencyContact = 'EmergencyContact',
}
